export const getCurrentUser = store => store.users.currentUser

export const getAuthenticationState = store => store.users.authentication
export const getRegistrationState = store => store.users.registration
export const getPasswordState = store => store.users.password
export const getUsers = store => store.users.users
export const getGuestUser = store => store.users.guestUser
